import ReactMarkdown from "react-markdown";

export default function Notes({ text }) {
  return (
    <div
      className="
        text-sm leading-relaxed
        [&_p]:m-0
        [&_ul]:m-0 [&_ol]:m-0
        [&_li]:m-0
        [&_ul]:list-disc [&_ol]:list-decimal
        [&_ul]:pl-5 [&_ol]:pl-5
        [&_p+ul]:mt-1 [&_ul+p]:mt-1 [&_p+p]:mt-1
      "
    >
      <ReactMarkdown>{text}</ReactMarkdown>
    </div>
  );
}